/**
 * Route for `conversion-scrub`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ConversionScrubPage } from "../features/conversion-scrub/ConversionScrubPage";

export const conversionScrubRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/conversion-scrub",
	component: ConversionScrubPage,
});

export default conversionScrubRoute;
